import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import checkStatus from './jsFunctions/checkStatus.js'

import { Box, Grid } from '@mui/material';

import Heading from './components/Heading/Heading';
import Heading6 from './components/Heading6/Heading6';
import Paragraph from './components/Paragraph/Paragraph';
import MainTemplate from './components/MainTemplate/MainTemplate';

import URL2 from './config.js'
import { useSelector } from 'react-redux';
import { getParentEmails, countFeeEligibleChildren } from './utils/parentHistoryHelpers.js';
import { queueConfirmationEmail } from './utils/helper-functions.js';
import {
    getCampusSessions,
    markCampusChargePaid,
    clearCampusPaymentCharges,
    clearPaymentResumeState,
} from './utils/campusPaymentCharges.js';
import { hasOutstandingCampusPayment, shouldRedirectToCompletion } from './utils/campusPaymentStatus.js';
import { buildPaymentResumeNavState } from './utils/paymentResume.js';

/**
 * Credit-only thank you — amounts come from server-calculated payment state.
 */
const Thankyou2 = () => {
    const location = useLocation();
    const [datePart, SetdatePart] = useState();
    const [timePart, SettimePart] = useState();
    const [Status, SetStatus] = useState();

    const state = location.state || {};
    const parentInfo = useSelector((state) => state.parentInfo);
    const parent_email = parentInfo.Email1 || parentInfo.par_email || getParentEmails(parentInfo.parentHistory).combined;
    let SessionID = state.SessionID;
    let parentID = state.parentID;
    let college = state.college;
    let famName = state.famName;
    let TotalResAmount = state.TotalResAmount;
    let TotalDepFees = state.TotalDepFees;
    let TotalSchoolFeeswodisc = state.TotalSchoolFeeswodisc;
    let TotalDiscount = state.TotalDiscount;
    let TotalFeesWithDiscount = state.TotalFeesWithDiscount;
    let PayableAmount = state.PayableAmount;
    let CustomAmount = state.CustomAmount;
    let RemainingAmount = state.RemainingAmount;
    let AmountPaidFromAICCredit = state.AmountPaidFromAICCredit;
    let AmountPaidFromBpoint = state.AmountPaidFromBpoint;
    let TransactionResponse = 'Paid from AIC Credit';
    let ReceiptNumber = 0;
    let BillerCode = 0;
    let MerchantNumber = 0;
    let SelectedDiscountValue = state.SelectedDiscountValue;
    let FTE = state.FTE;
    let RemAmountMethod = state.RemAmountMethod;

    const navigate = useNavigate();

    const persistCampusCharge = async (charge, responseText) => {
        const commonData = {
            SessionID: charge.SessionID,
            parentID: charge.parent_code || parentID,
            college: charge.college,
            famName,
            TotalResAmount: charge.TotalResAmount,
            TotalDepFees: charge.TotalDepFees,
            TotalSchoolFeeswodisc: charge.TotalSchoolFeeswodisc,
            TotalDiscount: charge.TotalDiscount,
            TotalFeesWithDiscount: charge.TotalFeesWithDiscount,
            PayableAmount: charge.PayableAmount ?? charge.payableAmount,
            CustomAmount: charge.CustomAmount,
            RemainingAmount: charge.RemainingAmount,
            AmountPaidFromAICCredit: charge.AmountPaidFromAICCredit,
            AmountPaidFromBpoint: charge.AmountPaidFromBpoint,
            TransactionResponse: responseText,
            ReceiptNumber: 0,
            BillerCode: 0,
            MerchantNumber: 0,
            datePart,
            timePart,
        };

        await Promise.all([
            URL2.post('/updateTransactioninpaydetails', commonData),
            URL2.post('/parent/parent-pay-detail-logs', commonData),
        ]);
        await URL2.post('/updatepaymentdata', {
            SessionID: charge.SessionID,
            TotalResAmount: charge.TotalResAmount,
            TotalDepFees: charge.TotalDepFees,
            CustomAmount: charge.CustomAmount,
        });
        await URL2.post('/generateFeereceipt', {
            SessionID: charge.SessionID,
            ParentID: charge.parent_code || parentID,
        });
        await queueConfirmationEmail({
            SessionID: charge.SessionID,
            parent_email,
            family_name: famName,
            college: charge.college || college,
            parent_id: charge.parent_code || parentID,
        });
    };

    const updateFeeStructuredata = async () => {
        return URL2.post('/updatefeestructuredata', {
            SelectedDiscountValue,
            FTE,
            feestruc_page_complete: 'Yes',
            SessionID,
            campusSessions: state.campusSessions || [],
            RemAmountMethod,
        });
    };

    useEffect(() => {
        const getDateTimeFunc = async () => {
            let dateTime = await URL2.post('/getDateTime');
            if (dateTime) {
                SetdatePart(dateTime.data.Date);
                SettimePart(dateTime.data.Time);
            }
        };
        getDateTimeFunc();
    }, []);

    useEffect(() => {
        if (localStorage.getItem('LoginToken') === null) {
            navigate('/');
            return;
        }

        checkStatus()
            .then((data) => {
                if (data && data.RenrolStatus !== undefined) {
                    SetStatus(data.RenrolStatus);
                    if (datePart && timePart && !shouldRedirectToCompletion(data)) {
                        const afterfetchTransactionResult = async () => {
                            if (
                                SessionID !== '' && parentID !== '' && college !== '' && famName !== '' &&
                                TotalResAmount !== '' && TotalDepFees !== '' && TotalSchoolFeeswodisc !== '' &&
                                TotalDiscount !== '' && TotalFeesWithDiscount !== '' && PayableAmount !== '' &&
                                CustomAmount !== '' && RemainingAmount !== '' && AmountPaidFromAICCredit !== '' &&
                                AmountPaidFromBpoint !== '' && TransactionResponse !== ''
                            ) {
                                // Prefer server amounts for credit-only path
                                try {
                                    const calcRes = await URL2.post('/calculatefees', {
                                        DiscountOption: SelectedDiscountValue,
                                        SD: state.SD,
                                        FTE,
                                        college,
                                        credit_amount: state.credit_amount,
                                        customAmount: state.customAmount ?? CustomAmount,
                                        enrolledchildrens: state.enrolledchildrens || state.childrens,
                                        NoOfChildren: countFeeEligibleChildren(state.enrolledchildrens || state.childrens),
                                        persist: true,
                                        SessionID,
                                        campusSessions: state.campusSessions || [],
                                        campusPaymentSelections: state.campusPaymentSelections || [],
                                        earlyBirdAvailable: state.earlyBirdAvailable,
                                        GiveHCCDiscount: state.GiveHCCDiscount,
                                    });
                                    const calc = calcRes.data;
                                    const campusCharges = calc?.campusBreakdown || [];

                                    await updateFeeStructuredata();

                                    if (campusCharges.length) {
                                        for (const charge of campusCharges) {
                                            if (charge.paymentStatus === 'paid') continue;
                                            // Campuses that still need a card payment are
                                            // left for the BPOINT run.
                                            if (Number(charge.AmountPaidFromBpoint) > 0) continue;
                                            await persistCampusCharge(charge, 'Paid from AIC Credit');
                                            markCampusChargePaid(charge.SessionID);
                                        }
                                    } else if (calc?.payment) {
                                        await persistCampusCharge({
                                            SessionID,
                                            parent_code: parentID,
                                            college,
                                            TotalResAmount: calc.totals.TotalResourceFees.toFixed(2),
                                            TotalDepFees: calc.totals.TotalDepositFees.toFixed(2),
                                            TotalSchoolFeeswodisc: calc.totals.TotalSchoolFees.toFixed(2),
                                            TotalDiscount: calc.totals.TotalDiscount.toFixed(2),
                                            TotalFeesWithDiscount: calc.totals.TotalFeesWithDiscount.toFixed(2),
                                            PayableAmount: calc.totals.PayableAmount.toFixed(2),
                                            CustomAmount: Number(calc.payment.AICCreditAmount).toFixed(2),
                                            RemainingAmount: calc.payment.BalanceDue.toFixed(2),
                                            AmountPaidFromAICCredit: Number(calc.payment.AICCreditAmount).toFixed(2),
                                            AmountPaidFromBpoint: calc.payment.BPointAmount.toFixed(2),
                                        }, 'Paid from AIC Credit');
                                    }
                                } catch (e) {
                                    console.error('Recalculate before credit payment failed, using nav state', e);
                                    await persistCampusCharge({
                                        SessionID,
                                        parent_code: parentID,
                                        college,
                                        TotalResAmount,
                                        TotalDepFees,
                                        TotalSchoolFeeswodisc,
                                        TotalDiscount,
                                        TotalFeesWithDiscount,
                                        PayableAmount,
                                        CustomAmount,
                                        RemainingAmount,
                                        AmountPaidFromAICCredit,
                                        AmountPaidFromBpoint,
                                    }, TransactionResponse);
                                }

                                // Credit rarely covers every campus, so any campus
                                // still owing sends the family back to the fee page
                                // rather than ending on this receipt.
                                const familyStatus = await checkStatus({ campusSessions: getCampusSessions() });
                                if (hasOutstandingCampusPayment(familyStatus)) {
                                    const resume = buildPaymentResumeNavState({
                                        statusData: familyStatus,
                                        ParentID: parentID,
                                        SessionID,
                                        college,
                                    });
                                    if (resume) {
                                        navigate('/payment', { replace: true, state: resume });
                                        return;
                                    }
                                } else if (familyStatus?.allComplete) {
                                    clearCampusPaymentCharges();
                                    clearPaymentResumeState();
                                }
                            }
                        };
                        afterfetchTransactionResult();
                    } else if (shouldRedirectToCompletion(data)) {
                        navigate('/reenrolmentcompleted', {
                            state: { t_date: data.t_date, t_time: data.t_time, campusStatuses: data.campusStatuses || [] },
                        });
                    }
                }
            })
            .catch((error) => {
                console.error('An error occurred:', error);
            });
    }, [parentID, college, datePart, timePart]);

    const content = (
        <>
            <Box mt={2}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sx={{ textAlign: 'center' }}>
                        <Heading text={'Thanks for the payment'} />
                        <Heading6 text={'Transaction Details'} />
                    </Grid>
                    <Grid item xs={12} sx={{ textAlign: 'center' }}>
                        <Paragraph text={`Parent ID: ${parentID}`} />
                    </Grid>
                    <Grid item xs={12} sx={{ textAlign: 'center' }}>
                        <Paragraph text={`Paid Amount: $${CustomAmount}`} />
                    </Grid>
                    <Grid item xs={12} sx={{ textAlign: 'center' }}>
                        <Paragraph text={`College: ${college}`} />
                    </Grid>
                    <Grid item xs={12} sx={{ textAlign: 'center' }}>
                        <Paragraph text={`Family Name: ${famName}`} />
                    </Grid>
                    <Grid item xs={12} sx={{ textAlign: 'center' }}>
                        <Paragraph text={`Transaction Date: ${datePart}`} />
                    </Grid>
                    <Grid item xs={12} sx={{ textAlign: 'center' }}>
                        <Paragraph text={`Transaction Time: ${timePart}`} />
                    </Grid>
                </Grid>
            </Box>
        </>
    );

    return (
        <>
            <MainTemplate content={content} SessionID={SessionID} college={college} />
        </>
    );
};

export default Thankyou2;
